var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-dropdown',{staticClass:"locale_switch",attrs:{"data-test-id":"localeSwitch","label":_vm.$i18n.locale,"collapsible":"","hoverable":""}},[_c('b-navbar-item',{attrs:{"href":"#"},on:{"click":_vm.switchLanguage}},[_vm._v(" en ")]),_c('b-navbar-item',{attrs:{"data-test-id":"localeHe"},on:{"click":_vm.switchLanguage}},[_vm._v(" he ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }